/**
 * @file Error constant
 * @module constant.error
 * @author Surmon <https://github.com/surmon-china>
 */

export const BAD_REQUEST = 400
export const FORBIDDEN = 403
export const NOT_FOUND = 404
export const INVALID_ERROR = 500
